import { FeedbackCard } from '../../components'

export const PasswordChangeRequest: React.FC = () => {
  return <FeedbackCard title="Te enviamos un mail para que puedas crear una nueva contraseña" />
}
